var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/last_session.b56105f8.png","uri@2x": __webpack_public_path__ + "static/media/last_session.d1a79d7d.png","uri@3x": __webpack_public_path__ + "static/media/last_session.96b30e68.png",
    width: 24,
    height: 25
});